export default {
  自助零售和游戏游艺: '自助零售和游戏游艺',
  自助零售: '自助零售',
  自助: '自助',
  游戏游艺: '游戏游艺',
  泳池Spa和游戏游艺: '泳池Spa和游戏游艺',
  泳池: '泳池',
  游艺: '游艺',
}
